import { useEffect } from 'react'
import { AbilityBuilder, createMongoAbility } from '@casl/ability'

import { useAbilityContext } from './useAbilityContext'

import { useAuth } from '@isdd/metais-common/contexts/auth/authContext'
import { getGetRightsForPOQueryKey, useGetRightsForPO } from '@isdd/metais-common/api/generated/iam-swagger'
import { ConfigurationItemUi, getGetRoleParticipantQueryKey, useGetRoleParticipant } from '@isdd/metais-common/api/generated/cmdb-swagger'
import { DOCUMENTS, PROJECT_STATUS, ROLES } from '@isdd/metais-common/constants'
import { getUniqueRules } from '@isdd/metais-common/permissions/helpers'
import { PROJECT_STATE_ENUM, VALIDATION_STATES } from '@isdd/metais-common/api'

export enum DocumentsActions {
    HANDLE = 'handle',
    DELETE = 'delete',
}

export const useProjectDocumentsPermissions = (projectData: ConfigurationItemUi | undefined, projectRoles: string[]) => {
    const abilityContext = useAbilityContext()
    const {
        state: { user },
    } = useAuth()
    const { data: roleParticipant } = useGetRoleParticipant(projectData?.metaAttributes?.owner ?? '', {
        query: { queryKey: getGetRoleParticipantQueryKey(projectData?.metaAttributes?.owner ?? ''), enabled: !!projectData },
    })
    const { data: rightsForPOData } = useGetRightsForPO(
        { identityUuid: user?.uuid ?? '', cmdbId: roleParticipant?.owner ?? '' },
        {
            query: {
                queryKey: getGetRightsForPOQueryKey({ identityUuid: user?.uuid ?? '', cmdbId: roleParticipant?.owner ?? '' }),
                enabled: !!roleParticipant && !!user,
            },
        },
    )

    useEffect(() => {
        const { can, rules: newRules } = new AbilityBuilder(createMongoAbility)
        const rolesForPO = rightsForPOData?.filter((role) => projectRoles?.find((currentRole) => currentRole === role.roleName))

        if (!VALIDATION_STATES.includes(projectData?.attributes?.[PROJECT_STATUS] as PROJECT_STATE_ENUM)) {
            if (rolesForPO && rolesForPO.length > 0) {
                can(DocumentsActions.HANDLE, DOCUMENTS)
            }
        } else {
            if (user?.roles.includes('PROJEKT_SCHVALOVATEL') || user?.roles.includes(ROLES.R_ADMIN)) {
                can(DocumentsActions.HANDLE, DOCUMENTS)
            }
        }
        if (user?.roles.includes(ROLES.R_ADMIN)) {
            can(DocumentsActions.DELETE, DOCUMENTS)
        }
        const existingRules = abilityContext.rules
        const updatedRules = getUniqueRules(newRules, existingRules)

        const mergedRules = [...existingRules, ...updatedRules]

        abilityContext.update(mergedRules)
    }, [abilityContext, projectData, projectRoles, rightsForPOData, user?.roles])

    return {}
}
